// Port aus chat/WissenSourceToggleBar.svelte — Quellenwahl im Wissens-Modus.
export type WissenSourceKey = 'web' | 'compendium' | 'pubmed' | 'europepmc' | 'clinicaltrials' | 'hausarzt';
export const WISSEN_SOURCES: { key: WissenSourceKey; label: string; desc: string }[] = [
  { key: 'web',            label: 'Internet',         desc: 'Allgemeine Web-Suche (DuckDuckGo)' },
  { key: 'compendium',     label: 'Compendium',       desc: 'compendium.ch — CH-Arzneimittel' },
  { key: 'pubmed',         label: 'PubMed',           desc: 'PubMed/MEDLINE — Publikationen' },
  { key: 'europepmc',      label: 'Europe PMC',       desc: 'Erweiterte Lit. inkl. Preprints & EU' },
  { key: 'clinicaltrials', label: 'ClinicalTrials',   desc: 'Klinische Studien (CH-Fokus)' },
  { key: 'hausarzt',       label: 'hausarzt-info.ch', desc: 'Dokumente, Merkblätter & Formulare von hausarzt-info.ch' },
];
export const WISSEN_DEFAULTS: Record<WissenSourceKey, boolean> = { web: true, compendium: true, pubmed: true, europepmc: true, clinicaltrials: true, hausarzt: true };

export default function WissenSourceToggleBar({ sourceEnabled, onChange }: { sourceEnabled: Record<WissenSourceKey, boolean>; onChange: (v: Record<WissenSourceKey, boolean>) => void }) {
  const noneActive = WISSEN_SOURCES.every((s) => !sourceEnabled[s.key]);
  return (
    <div className="flex items-center gap-1.5 overflow-x-auto border-b border-gray-200 bg-gray-50 px-4 py-1.5 sm:px-6">
      <span className="mr-0.5 shrink-0 text-[10px] font-medium uppercase tracking-wider text-ps-dark-500">Quellen</span>
      {WISSEN_SOURCES.map((s) => {
        const active = sourceEnabled[s.key];
        return (
          <button key={s.key} type="button" onClick={() => onChange({ ...sourceEnabled, [s.key]: !active })} title={s.desc + (active ? ' — aktiv' : ' — abgeschaltet')}
            className={`inline-flex shrink-0 items-center gap-1 rounded border px-2 py-0.5 text-[11px] font-medium transition-colors ${active
              ? 'border-primary-300 bg-primary-50 text-primary-500 hover:bg-primary-500 hover:text-white'
              : 'border-gray-200 bg-white text-ps-dark-400 line-through opacity-70 hover:border-gray-300'}`}>{s.label}</button>
        );
      })}
      {noneActive && <span className="ml-1 shrink-0 text-[10.5px] text-amber-700">⚠ keine aktiv</span>}
    </div>
  );
}
